var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tito-locked-ticket-message"},[_c('p',[_vm._v(_vm._s(_vm.$t("views.registrations.locked_ticket_warning", _vm.locale)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }